import { Injectable } from '@angular/core';
import { Preview, PreviewTypeId } from '../models/preview.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ProcessProviderId } from '../../loyalty/marketplace/models/process-provider-id';

export interface PreviewState extends EntityState<Preview> {}
@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'preview', cache: { ttl: 30000 }, idKey: '_id' })
export class PreviewStore extends EntityStore<PreviewState> {
  ProcessProviderId = ProcessProviderId;
  PreviewTypeId = PreviewTypeId;
  constructor() {
    super();
  }

  akitaPreAddEntity(newEntity: any): Preview & { _id: string } {
    let id;
    if (newEntity.ScorecardId) {
      id = newEntity.ScorecardId + PreviewTypeId.scorecard;
    }
    if (newEntity.LottoId) {
      id = newEntity.LottoId + PreviewTypeId.lotto;
    }
    if (newEntity.AuctionItem) {
      id = newEntity.AuctionItem.Id + PreviewTypeId.auction;
    }
    if (ProcessProviderId[newEntity.ProcessProviderId]) {
      id = newEntity.Id + PreviewTypeId.marketplace;
    }
    return {
      ...newEntity,
      _id: id,
    };
  }
}
